exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.footer-copyright {\n  height: 50px;\n  line-height: 50px;\n  font-size: 12px;\n  color: #6b778c;\n  text-align: center; }\n  .footer-copyright.-default {\n    background-color: #f6f8f9; }\n  .footer-copyright.-affiliate-login {\n    background-color: #FFFFFF; }\n\n@media screen and (max-width: 768px) {\n  .footer-copyright {\n    height: auto;\n    padding: 5px 0;\n    line-height: 1.4em;\n    font-size: 12px; }\n    .footer-copyright.-affiliate-login {\n      background-color: #f6f8f9; }\n    .footer-copyright .copyright-inner {\n      width: 255px;\n      margin: 0 auto; } }\n\n@media screen and (max-width: 1120px) {\n  .footer-copyright.-affiliate-login {\n    background-color: #f6f8f9; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer-copyright/footer-copyright.component.scss
// module id = 893
// module chunks = 22